module.exports = __webpack_public_path__ + "img/6.a7d93672.png";